import { render, staticRenderFns } from "./TopHeader.vue?vue&type=template&id=56db56c4&scoped=true"
import script from "./TopHeader.vue?vue&type=script&lang=js"
export * from "./TopHeader.vue?vue&type=script&lang=js"
import style0 from "./TopHeader.vue?vue&type=style&index=0&id=56db56c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56db56c4",
  null
  
)

export default component.exports